import { useState } from 'react'
import { usePlanPayments } from '../api/planPayments'
import { Modal } from 'components/modal'
import { Box, Flex } from 'components/elements'
import { errorMessage, getUpperCase } from 'utils/function'
import { ErrorBox } from 'features/profile/components/EditProfileForm'
import StripeComponent from 'features/stripe/page/StripeComponent'
import StripePayment from 'features/stripe/components/StripePayment'
import { BoxCss, Notification, textCss } from 'features/quote/components/GetAQuoteProcess/QuoteReview'
import { DetailContainer, InfoColumn, MainWrapCSS } from 'features/incidents/components/style'
import { AxiosError } from 'axios'

type ManualPaymentProps = {
  setOpenManualPaymentModal: (value: boolean) => void
  manualPaymentModal: boolean
  discountAmount: number
  basePremium: number
  discountedAmount: number
  setManualPaymentNotification: (value: boolean) => void
}
const ManualPayment = (props: ManualPaymentProps) => {
  const { discountAmount, basePremium, discountedAmount, manualPaymentModal, setOpenManualPaymentModal, setManualPaymentNotification } = props
  const [paymentError, setPaymentError] = useState('')
  const totalDiscount = (discountAmount / basePremium) * 100

  const { mutate, isLoading } = usePlanPayments()

  const handleStripeSubmit = (paymentMethodId: string) => {
    const newObj = {
      paymentMethodId,
      isAutoSubscriptionEnabled: true,
    }

    mutate(newObj, {
      onSuccess: () => {
        setOpenManualPaymentModal(false)
        setManualPaymentNotification(true)
      },
      onError: error => {
        if (error instanceof AxiosError) {
          setPaymentError(errorMessage(error))
        }
      },
    })
  }
  const handleCancel = () => {
    setOpenManualPaymentModal(false)
  }
  return (
    <>
      <Modal
        active={manualPaymentModal}
        hideModal={() => {
          setOpenManualPaymentModal(false)
        }}
        children={
          <>
            <Flex justify={'between'} wrap={'wrap'} css={{ mb: '$3', rowGap: '1rem' }}>
              <Box as="h4" css={{ textAlign: 'start', m: 0 }}>
                Payment Information
              </Box>
              {discountAmount && (
                <Notification>
                  <Box as="span" css={{ textAlign: 'center' }}>
                    You saved {totalDiscount}%
                  </Box>
                </Notification>
              )}
            </Flex>
            <Box>
              <Box
                className="detail-box"
                style={{ padding: 0 }}
                css={{
                  ...MainWrapCSS,
                  background: '$cardGradient',
                  borderRadius: '8px',
                  mb: '$5',
                }}
              >
                <DetailContainer className="custom--grid">
                  <InfoColumn css={BoxCss}>
                    <Box as="p" className="t-title m-0">
                      Original Premium
                    </Box>
                    <Box as="p" className={`t-value `} css={textCss}>
                      ${basePremium}
                    </Box>
                  </InfoColumn>
                  <InfoColumn css={BoxCss}>
                    <Box as="p" className="t-title m-0" css={{ wordBreak: 'auto-phrase !important' }}>
                      Discounted Premium
                    </Box>
                    <Box as="p" className={`t-value `} css={{ ...textCss, color: '$primary', fontSize: '$xl' }}>
                      ${discountedAmount}
                    </Box>
                  </InfoColumn>
                </DetailContainer>
              </Box>
            </Box>
            <Box as="h4" css={{ textAlign: 'start' }}>
              Card Information
            </Box>

            <Flex direction="column" css={{ gap: '$5' }}>
              {!!paymentError && <ErrorBox css={{ textAlign: 'left', mb: '$3' }}>{getUpperCase(paymentError)}</ErrorBox>}
              <StripeComponent WrappedComponent={() => <StripePayment onSubmit={handleStripeSubmit} isLoading={isLoading} IsOpenInModal={true} handleCancel={handleCancel} />} />
            </Flex>
          </>
        }
        title="Manual Payment"
        isFooterHidden={true}
        description={''}
        acceptText={''}
      />
    </>
  )
}

export default ManualPayment
